<template>
   <div class="text-center " >

        <form class="form-signin mt-5" @submit.prevent>
            <!-- <img class="mb-4" src="https://getbootstrap.com/docs/4.0/assets/brand/bootstrap-solid.svg" alt="" width="72" height="72"> -->
            <!-- <svg width="5em" height="5em" viewBox="0 0 16 16" class="bi bi-bicycle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M3 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm10-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
            <path fill-rule="evenodd" d="M4 4.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1v.5h4.14l.386-1.158A.5.5 0 0 1 11 4h1a.5.5 0 0 1 0 1h-.64l-.311.935 2.375 3.8a.5.5 0 1 1-.848.53L10.5 6.943l-2.076 3.322A.5.5 0 0 1 8 10.5H3a.5.5 0 0 1-.424-.765L5 5.857V5h-.5a.5.5 0 0 1-.5-.5zm1.5 2.443L3.902 9.5h3.196L5.5 6.943zM8 9.057L9.598 6.5H6.402L8 9.057z"/>
            </svg> -->
            <h1 class="h3 mb-3 font-weight-normal">Serwis</h1>
            <img class="my-5" src="../assets/zicobikelogo.png">
            
            <input v-model.trim="loginForm.email" id="inputEmail" type="email" class="form-control" placeholder="Email" required autofocus>
            <input v-model.trim="loginForm.password" id="inputPassword" type="password" class="form-control" placeholder="Hasło" required autofocus>
            <div class="checkbox mb-3">
                <label>
                <input type="checkbox" value="remember-me"> Zapamiętaj mnie
                </label>
            </div>
            <button @click="login()" class="btn btn-lg btn-primary btn-block">Zaloguj się</button>
            <p class="mt-5 mb-3 text-muted">© 2025 <a href="https://2qbs.pl" target="_blank">2Qbs</a></p>
        </form>
        <!-- <form v-else @submit.prevent>
            <input v-model.trim="signupForm.name" type="text" placeholder="Imie" />
        
            <input v-model.trim="signupForm.title" type="text" placeholder="Nazwisko"  />
          
            <input v-model.trim="signupForm.email" type="text" placeholder="Email" />
          
            <input v-model.trim="signupForm.password" type="password" placeholder="min 6 znaków" />
            <button @click="signup()" class="btn btn-success">Zarejestruj się</button>
        </form>
        <button @click="toggleForm()">Zarejestruj się</button> -->

 
    </div>

    
</template>
<script>

export default {
    data() {
        return {
            loginForm: {
                email: '',
                password: '',
            },
            signupForm: {
                name: '',
                title: '',
                email: '',
                password: ''
            },
            showLoginForm: true,
            showPasswordReset: false,
        }
    },
    methods: {
        toggleForm(){
            this.showLoginForm = !this.showLoginForm
        },
        tooglePasswordReset() {
            this.showPasswordReset = !this.showPasswordReset
        },
        login() {
            this.$store.dispatch('login', {
                email: this.loginForm.email,
                password: this.loginForm.password
            })
        },
        signup() {
            this.$store.dispatch('signup', {
                email: this.signupForm.email,
                password: this.signupForm.password,
                name: this.signupForm.name,
                title: this.signupForm.title
                
            })
        }
    }
    
}
</script>
<style scoped>
.form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
}
#inputEmail{
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin-top:10px;
    margin-bottom:2px
    
}
#inputPassword {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin-bottom:10px;
}
</style>